import {TrafficLightColor} from '@singularit/kurz-components'

export const calcTrendColor = (val: number) => {
  if (!val) return TrafficLightColor.DEFAULT
  else if (val > 0.05) return TrafficLightColor.GREEN
  else if (val < 0.05 && val > -0.05) return TrafficLightColor.YELLOW
  else if (val < -0.05) return TrafficLightColor.RED
}
